import { Grid, Paper, Skeleton } from "@mui/material";
import PropertyMap from "../common/PropertyMap";

type PropertyDetailsMapProps = {
  property: any;
};

const PropertyDetailsMap = ({ property }: PropertyDetailsMapProps) => {
  return (
    <Grid item xs={12}>
      <Paper
        elevation={0}
        sx={{
          boxShadow: "0 4px 4px 0 rgba(23, 23, 23, 0.06)",
          width: "100%",
          padding: "0",
          borderRadius: "1rem",
        }}
      >
        {property ? (
          <PropertyMap
            sx={{
              height: "23.4rem",
              borderRadius: "1rem",
            }}
            propertyData={[property?.propertyDetails]}
          />
        ) : (
          <Skeleton
            variant="rectangular"
            width={"100%"}
            height={300}
            sx={{ borderRadius: "1rem" }}
          />
        )}
      </Paper>
    </Grid>
  );
};

export default PropertyDetailsMap;
